import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSession } from '../lib/auth-client';
import { api } from '../lib/api';

/**
 * ❤️ زر المفضلة — يحفظ/يحذف العقار من مفضلة المستخدم
 */
export function FavoriteButton({ propertyId, size = 'md', className = '' }: {
  propertyId: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const qc = useQueryClient();
  const { data: session } = useSession();

  const { data } = useQuery({
    queryKey: ['my-favorites'],
    queryFn: () => api.get<{ data: Array<{ propertyId: string }> }>('/api/favorites'),
    enabled: !!session?.user,
    staleTime: 60_000,
  });
  const isFav = !!data?.data?.find((f) => f.propertyId === propertyId);

  const addM = useMutation({
    mutationFn: () => api.post(`/api/favorites/${propertyId}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['my-favorites'] }),
  });
  const removeM = useMutation({
    mutationFn: () => api.delete(`/api/favorites/${propertyId}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['my-favorites'] }),
  });

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!session?.user) {
      window.location.href = '/login';
      return;
    }
    if (isFav) removeM.mutate();
    else addM.mutate();
  };

  const sizes = {
    sm: 'w-8 h-8 text-base',
    md: 'w-10 h-10 text-xl',
    lg: 'w-12 h-12 text-2xl',
  };

  return (
    <button
      onClick={handleClick}
      className={`${sizes[size]} rounded-full flex items-center justify-center transition shadow-brand ${
        isFav
          ? 'bg-pink-100 text-pink-600 hover:bg-pink-200'
          : 'bg-white text-ink-muted hover:bg-pink-50 hover:text-pink-500'
      } ${className}`}
      title={isFav ? 'إزالة من المفضلة' : 'إضافة للمفضلة'}
      disabled={addM.isPending || removeM.isPending}
    >
      {isFav ? '❤️' : '🤍'}
    </button>
  );
}
